export enum EntraUserRole {
  SuperAdmin = "SuperAdmin",
  Reader = "Reader"
}

export class User {
  readonly id: string;
  readonly name: string;
  readonly roles: string[];

  constructor(id: string, name: string, roles: string[]) {
    this.id = id;
    this.name = name;
    this.roles = roles;
  }

  get isSuperAdmin(): boolean {
    return this.roles.includes(EntraUserRole.SuperAdmin);
  }

  get isReader(): boolean {
    return this.roles.includes(EntraUserRole.Reader);
  }
}
